<template>
  <div>
    <div class="row" v-for="(name,idx) in dataArr" :key="idx">
      <div class="col-1">
        <label for="name">{{ idx }}</label>
      </div>
      <div class="col-7">
        <div class="form-group">
          <input class="form-control discountLbl" :id="'dimensions-name-' + idx" v-model="dataArr[idx]" @keyup="updateDimensionsData()"/>
        </div>
      </div>
      <div class="col-4">
        <button class="btn btn-danger" @click="deleteDimensionsData(idx)">
          <span class="spinner-border spinner-border-sm spinDel d-none" :id="'spinnerDimensions_'+idx" role="status" aria-hidden="true"></span>
          Delete
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="addDimensionsData">
          <span class="spinner-border spinner-border-sm spinAdd d-none" id="spinnerAddDimensions" role="status" aria-hidden="true"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Reconstructed 2026-10-05 from the compiled admindev build (built 2026-05-29):
// this file was never committed. Replace with Matt's original when he pushes it.

import {mapGetters} from "vuex";

export default {
  name: "Dimensions",
  data() {
    return {
      dataArr: []
    };
  },
  emits: {
    updateDimensions: null
  },
  computed: {
    ...mapGetters({
      'dimensionsData': 'product/getDimensionsData',
    }),
  },
  methods: {
    addDimensionsData() {
      document.querySelector('#spinnerAddDimensions').classList.remove('d-none');
      this.$store.dispatch('product/addDimensions', {name: '*******', active: 1}).then(rez => {
        this.dataArr[rez.id] = rez.name
        this.$emit('updateDimensions', this.dataArr)
        document.querySelector('#spinnerAddDimensions').classList.add('d-none');
      })
    },
    deleteDimensionsData(id) {
      document.querySelector('#spinnerDimensions_'+id).classList.remove('d-none');
      this.$store.dispatch('product/deleteDimensions', {id}).then(rez => {
        if(rez.success) {
          delete this.dataArr[id]
          this.$emit('updateDimensions', this.dataArr)
        }
        document.querySelector('#spinnerDimensions_'+id).classList.add('d-none');
      })
    },
    updateDimensionsData() {
      this.$emit('updateDimensions', this.dataArr)
    }
  },
  mounted() {
    this.dataArr = this.dimensionsData
    this.$store.dispatch('product/getDimensions').then(() => {
      this.dataArr = this.dimensionsData
      this.$emit('updateDimensions', this.dataArr)
    })
  }
};
</script>
<style scoped>

.spinDel{
  position: absolute;
  left:35px;
  top:10px;
}

.spinAdd{
  position: absolute;
  top:10px;
}

</style>
